import { render } from "./GrattersListComponent.vue?vue&type=template&id=a6c7bc6c"
import script from "./GrattersListComponent.vue?vue&type=script&lang=js"
export * from "./GrattersListComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__